import { Button } from '@/components/ui/button'
import { useAuthModal } from '@/context/AuthModalContext'

export function UnauthenticatedActions() {
	const { openLogin, openRegister } = useAuthModal()

	return (
		<div className='flex items-center gap-2'>
			<Button type='button' variant='secondary' onClick={openLogin}>
				Login
			</Button>
			<Button type='button' variant='primary' onClick={openRegister}>
				Register
			</Button>
		</div>
	)
}
